"use client";

import React from "react";
import { MapPin, Phone, Clock, Mail } from "lucide-react";
export default function Footer() {
  return <footer className="bg-[#071B3A] text-white">
      <div className="max-w-[1180px] mx-auto px-4 lg:px-8 py-5 lg:py-6">
        
        <div className="grid grid-cols-1 lg:grid-cols-[1.1fr_1fr_1.2fr] gap-5 lg:gap-8 items-start">
          
          {/* BRAND */}
          <div>
            <h3 className="font-black italic uppercase text-[18px] lg:text-[22px] leading-tight">
              Nova Tire Center
            </h3>


            <p className="mt-2 text-white/65 text-[12px] lg:text-[13px] leading-snug max-w-[330px]">
              Tire repair, replacement and balancing in Los Angeles.
              Open 7 days. Walk-ins welcome.
            </p>
          </div>


          {/* QUICK LINKS */}
          <div className="grid grid-cols-2 gap-4 lg:gap-6">
            <div>
              <h4 className="font-black uppercase text-[11px] text-white mb-2">
                Services
              </h4>


              <ul className="space-y-1.5 text-white/65 text-[12px] lg:text-[13px]">
                <li><a href="https://novatirecenter.com/flat-tire-repair-los-angeles/" className="hover:text-white">Flat Tire Repair</a></li>
                <li><a href="https://novatirecenter.com/tire-shop-los-angeles/" className="hover:text-white">Tire Replacement</a></li>
                <li>TPMS Service</li>
              </ul>
            </div>


            <div>
              <h4 className="font-black uppercase text-[11px] text-white mb-2">
                Company
              </h4>


              <ul className="space-y-1.5 text-white/65 text-[12px] lg:text-[13px]">
                <li>Contact</li>
                <li>Location</li>
                <li>Same-Day Service</li>
              </ul>
            </div>
          </div>


          {/* CONTACT */}
          <div>
            <h4 className="font-black uppercase text-[11px] text-white mb-2">
              Contact
            </h4>


            <div className="grid gap-2 text-white/70 text-[12px] lg:text-[13px] leading-snug">
              <div className="flex gap-2">
                <MapPin className="w-4 h-4 text-[#7DB2FF] shrink-0 mt-0.5" />
                <span>8635 W Pico Blvd, Los Angeles, CA 90035</span>
              </div>


              <div className="flex gap-2">
                <Clock className="w-4 h-4 text-[#7DB2FF] shrink-0 mt-0.5" />
                <span>Mon–Fri: 8 AM–6 PM · Sat–Sun: 9 AM–7 PM</span>
              </div>


              <div className="flex gap-2">
                <Phone className="w-4 h-4 text-[#7DB2FF] shrink-0 mt-0.5" />
                <a href="tel:+14243138474" className="hover:text-white">
                  (424) 313-8474
                </a>
              </div>


              <div className="flex gap-2">
                <Mail className="w-4 h-4 text-[#7DB2FF] shrink-0 mt-0.5" />
                <a href="mailto:info@novatirecenter.com" className="hover:text-white">
                  info@novatirecenter.com
                </a>
              </div>
            </div>
          </div>


        </div>


        {/* BOTTOM */}
        <div className="mt-4 lg:mt-5 pt-3 border-t border-white/10 text-center">
          <p className="text-white/40 text-[10px] lg:text-[11px]">
            © 2026 Nova Tire Center · Los Angeles Tire Service · Same-Day · No Appointment Needed
          </p>
        </div>


      </div>
    </footer>;
}